{
  "common": {
    "loading": "Belastning...",
    "cancel": "Avboka",
    "save": "Spara",
    "save_changes": "Spara ändringar",
    "delete": "Radera",
    "edit": "Redigera",
    "close": "Nära",
    "submit": "Överlämna",
    "saving": "Sparande...",
    "sending": "Sändning...",
    "error": "Fel",
    "success": "Framgång",
    "warning": "Varning",
    "note": "Obs",
    "no_data": "Inga uppgifter",
    "yes": "Ja",
    "no": "Inga",
    "back": "Tillbaka",
    "next": "Nästa",
    "previous": "Tidigare",
    "search": "Söka",
    "filter": "Filtrera",
    "all": "Alla",
    "none": "Ingen",
    "select": "Välja",
    "required": "Nödvändig",
    "optional": "Frivillig",
    "actions": "Åtgärder",
    "status": "Status",
    "date": "Datum",
    "time": "Tid",
    "name": "Namn",
    "email": "E-post",
    "confirm": "Bekräfta",
    "add": "Lägg till",
    "done": "Klar",
    "unknown": "Okänd",
    "days": "dagar",
    "to": "till"
  },
  "time": {
    "day": "dag",
    "days": "dagar",
    "hour": "timme",
    "hours": "timmar",
    "week": "vecka",
    "weeks": "veckor",
    "month": "månad",
    "months": "månader",
    "year": "år",
    "years": "år",
    "today": "I dag",
    "tomorrow": "I morgon",
    "yesterday": "I går"
  },
  "status": {
    "pending": "I avvaktan på",
    "approved": "Godkänd",
    "rejected": "Avvisad",
    "cancelled": "Avbruten",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "deleted": "Borttagen",
    "connected": "Ansluten",
    "disconnected": "Osammanhängande",
    "available": "Tillgänglig",
    "coming_soon": "Kommer snart"
  },
  "nav": {
    "dashboard": "Instrumentpanel",
    "planner": "Planerare",
    "team": "Team",
    "requests": "Förfrågningar",
    "calendar": "Kalender",
    "settings": "Inställningar",
    "audit_trail": "Revisionslogg",
    "billing": "Fakturering",
    "help": "Hjälp",
    "help_center": "Hjälpcenter",
    "profile": "Profil",
    "my_balances": "Mina saldon",
    "leave_history": "Ledighetshistorik",
    "restart_tour": "Starta om turen",
    "logout": "Logga ut",
    "upgrade": "Uppgradera till Pro",
    "upgrade_subtitle": "Lås upp alla funktioner",
    "view_plans": "Visa planer"
  },
  "header": {
    "profile_settings": "Profilinställningar",
    "my_profile": "Min profil",
    "workspace": "Arbetsyta",
    "leave_balances": "Ledighetssaldon",
    "no_balances": "Inga ledighetstillfällen hittades."
  },
  "balance": {
    "unlimited": "Obegränsat",
    "days_left": "dagar kvar",
    "used": "begagnad",
    "remaining": "återstående",
    "of": "av"
  },
  "trial": {
    "ends_today": "Din provperiod slutar idag!",
    "ends_tomorrow": "Din rättegång slutar imorgon!",
    "ends_in_days": "Testperioden slutar om {days} dagar.",
    "upgrade_now": "Uppgradera nu"
  },
  "feature_locked": {
    "title": "{feature} är inte tillgänglig i ditt abonnemang",
    "description": "Uppgradera ditt abonnemang för att låsa upp den här funktionen och mer.",
    "button": "Visa planer"
  },
  "dashboard": {
    "title": "Instrumentpanel",
    "out_today": "Ute idag",
    "out_on_date": "Ute den {datum}",
    "no_absences": "Ingen frånvaro",
    "upcoming": "Kommande frånvaro",
    "upcoming_empty": "Ingen kommande frånvaro denna vecka",
    "my_balance": "Mitt semestersaldo",
    "my_balances": "Mina saldon",
    "no_balance_data": "Ingen saldodata",
    "next_holiday": "Nästa helgdag",
    "no_holidays": "Inga kommande helgdagar",
    "next_vacation": "Min nästa semester",
    "nothing_booked": "Inget bokat!",
    "upcoming_birthdays": "Kommande födelsedagar",
    "no_birthdays": "Inga kommande födelsedagar",
    "birthday_today": "I dag!",
    "birthday_in_days": "om {days} {unit}",
    "everyone_in_office": "Alla är på kontoret den här dagen",
    "request_leave": "Begär ledighet",
    "view_calendar": "Visa kalender",
    "view_planner": "Visa Planner",
    "contact_support": "Kontakta supporten"
  },
  "support": {
    "title": "Kontakta supporten",
    "success_title": "Meddelande skickat!",
    "success_message": "Vi återkommer till dig så snart som möjligt.",
    "intro": "Behöver du hjälp? Skicka ett meddelande så återkommer vi till dig inom kort.",
    "subject_label": "Ämne",
    "subject_placeholder": "Kort beskrivning av ditt problem",
    "message_label": "Meddelande",
    "message_placeholder": "Beskriv ditt problem eller din fråga i detalj...",
    "send_button": "Skicka meddelande"
  },
  "requests": {
    "page_title": "Ledighetsansökningar",
    "page_subtitle": "Granska och hantera ledighetsansökningar",
    "new_request": "Begär ledighet",
    "unpaid_confirm": "Endast {paid} {unit} av denna begäran täcks av ditt betalda saldo. Resterande {unpaid} {unit} tas som obetald ledighet. Skicka ändå?",
    "filter": {
      "pending": "I avvaktan på",
      "approved": "Godkänd",
      "rejected": "Avvisad",
      "all": "Alla",
      "all_employees": "Alla anställda"
    },
    "table": {
      "employee": "Anställd",
      "type": "Typ",
      "dates": "Datum",
      "duration": "Varaktighet",
      "status": "Status",
      "reason": "Resonera",
      "actions": "Åtgärder"
    },
    "action": {
      "approve": "Godkänna",
      "reject": "Avvisa",
      "cancel": "Avboka"
    },
    "empty": {
      "title": "Inga förfrågningar hittades",
      "pending": "Inga väntande förfrågningar att granska.",
      "filtered": "Inga ledighetsansökningar matchar ditt filter."
    },
    "modal": {
      "reject_title": "Avvisa begäran",
      "reason_label": "Anledning till avslag",
      "reason_placeholder": "Anledning till ledighetsansökan...",
      "reject_button": "Avvisa",
      "request_title": "Begär ledighet",
      "employee_label": "Anställd",
      "leave_type_label": "Typ av ledighetsstämning",
      "start_date_label": "Startdatum",
      "end_date_label": "Slutdatum",
      "start_time_label": "Starttid",
      "end_time_label": "Sluttid",
      "reason_optional": "Orsak (valfritt)",
      "submit_button": "Skicka begäran",
      "submitting": "Skickar in...",
      "minimum_duration": "Minimum: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Teamkalender",
    "page_subtitle": "Visa teamfrånvaro och schemalagd ledighet",
    "filters": {
      "button": "Filter"
    },
    "sync": {
      "title": "Synkronisera din kalender",
      "description": "Anslut din personliga kalender för att automatiskt synkronisera godkänd ledighet"
    },
    "connect": {
      "google": "Google Kalender",
      "microsoft": "Microsoft Kalender"
    },
    "action": {
      "disconnect": "Koppla från",
      "sync_my_leave": "Synkronisera min ledighet",
      "sync_team_leave": "Synkronisera teamets lämnande"
    },
    "connecting": "Ansluter...",
    "syncing": "Synkroniserar...",
    "autosync": {
      "title": "Synkronisera teamledighet automatiskt",
      "description": "Lägg automatiskt till teammedlemmars godkända ledighet i din kalender"
    },
    "filter": {
      "department_label": "Avdelning",
      "all_departments": "Alla avdelningar",
      "location_label": "Plats",
      "all_locations": "Alla platser",
      "leave_type_label": "Typ av ledighetsstämning",
      "all_types": "Alla typer",
      "status_label": "Status",
      "all_status": "All status"
    },
    "nav": {
      "today": "I dag"
    },
    "view": {
      "day": "Dag",
      "week": "Vecka",
      "month": "Månad"
    },
    "legend": {
      "pending": "I avvaktan på",
      "holiday": "Semester"
    },
    "day_view": {
      "empty": "Inga löv denna dag"
    },
    "more": "+{count} till"
  },
  "team": {
    "page_title": "Team",
    "page_subtitle": "Hantera dina teammedlemmar",
    "tab": {
      "active": "Aktiva",
      "inactive": "Inaktiva",
      "deleted": "Borttagna"
    },
    "add_user": "Lägg till användare",
    "import_from_slack": "Importera från Slack",
    "search_placeholder": "Sök teammedlemmar...",
    "table": {
      "name": "Namn",
      "email": "E-post",
      "department": "Avdelning",
      "location": "Plats",
      "role": "Roll",
      "status": "Status",
      "manager": "Chef",
      "start_date": "Startdatum",
      "birthday": "Födelsedag",
      "working_days": "Arbetsdagar",
      "hours_per_week": "Timmar per vecka",
      "employment_type": "Anställningstyp",
      "actions": "Åtgärder"
    },
    "filter": {
      "all_departments": "Alla avdelningar",
      "all_locations": "Alla platser",
      "all_roles": "Alla roller",
      "search_placeholder": "Sök efter namn eller e-post..."
    },
    "role": {
      "owner": "Ägare",
      "admin": "Administratör",
      "approver": "Godkännare",
      "employee": "Anställd"
    },
    "card": {
      "department": "Avdelning",
      "location": "Plats",
      "manager": "Chef",
      "role": "Roll",
      "email": "E-post",
      "start_date": "Startdatum",
      "birthday": "Födelsedag",
      "working_days": "Arbetsdagar",
      "balance": "Saldo",
      "no_manager": "Ingen chef tilldelad",
      "no_department": "Ingen avdelning",
      "no_location": "Ingen plats"
    },
    "action": {
      "edit": "Redigera",
      "view": "Visa",
      "deactivate": "Avaktivera",
      "activate": "Aktivera",
      "delete": "Radera",
      "restore": "Återställa",
      "permanent_delete": "Ta bort permanent",
      "adjust_balance": "Justera saldo",
      "view_history": "Visa historik",
      "send_invite": "Skicka inbjudan",
      "resend_invite": "Skicka inbjudan igen",
      "cancel_invite": "Avbryt inbjudan"
    },
    "empty": {
      "title": "Inga teammedlemmar hittades",
      "description": "Kom igång genom att lägga till teammedlemmar eller importera från Slack.",
      "active": "Det finns inga aktiva användare.",
      "inactive": "Det finns inga inaktiva användare.",
      "deleted": "Det finns inga borttagna användare.",
      "search": "Inga användare matchar din sökning."
    },
    "modal": {
      "add_title": "Lägg till teammedlem",
      "edit_title": "Redigera teammedlem",
      "view_title": "Teammedlemsinformation",
      "import_title": "Importera från Slack",
      "balance_title": "Justera saldo",
      "name_label": "Fullständigt namn",
      "email_label": "E-postadress",
      "department_label": "Avdelning",
      "location_label": "Plats",
      "role_label": "Roll",
      "manager_label": "Chef",
      "start_date_label": "Startdatum",
      "birthday_label": "Födelsedag",
      "working_days_label": "Arbetsdagar",
      "hours_per_week_label": "Timmar per vecka",
      "employment_type_label": "Anställningstyp",
      "select_department": "Välj avdelning",
      "select_location": "Välj plats",
      "select_manager": "Välj chef",
      "select_role": "Välj roll",
      "no_manager": "Ingen chef"
    },
    "toil": {
      "title": "Kompledighet (TOIL)",
      "add_button": "Lägg till TOIL",
      "hours_worked": "Arbetade timmar",
      "date_worked": "Datum arbetat",
      "description": "Beskrivning",
      "expiry_date": "Utgångsdatum",
      "balance": "TOIL-saldo",
      "no_records": "Inga TOIL-poster hittades"
    },
    "invite": {
      "title": "Bjud in teammedlem",
      "subtitle": "Skicka en inbjudan via e-post eller Slack",
      "email_label": "E-postadress",
      "email_placeholder": "namn@foretag.se",
      "slack_user_label": "Eller välj Slack-användare",
      "send_button": "Skicka inbjudan",
      "success": "Inbjudan skickad!",
      "pending": "Inbjudan väntar",
      "expired": "Inbjudan utgången"
    },
    "bulk": {
      "title": "Massimport",
      "import_button": "Massimport",
      "description": "Importera flera användare från en CSV-fil eller från Slack.",
      "csv_upload": "Ladda upp CSV-fil",
      "slack_import": "Importera från Slack",
      "template_download": "Ladda ner mall",
      "mapping_title": "Kolumnmappning",
      "preview_title": "Förhandsgranskning",
      "import_count": "{count} användare kommer att importeras",
      "success": "{count} användare importerade!",
      "errors_found": "{count} fel hittades"
    },
    "instances": {
      "title": "Ledighetsinstanser",
      "used": "Använd",
      "remaining": "Återstående",
      "lifetime_limit": "Livstidsgräns",
      "no_limit": "Ingen gräns",
      "history": "Historik"
    },
    "confirm": {
      "deactivate": "Är du säker på att du vill inaktivera den här användaren?",
      "deactivate_warning": "Användaren kommer inte längre att kunna logga in eller begära ledighet.",
      "activate": "Är du säker på att du vill aktivera den här användaren?",
      "delete": "Är du säker på att du vill ta bort den här användaren? De kommer att flyttas till fliken Borttagna.",
      "permanent_delete": "Är du säker på att du vill RADERA {name} PERMANENT?",
      "permanent_delete_warning": "Den här åtgärden kan inte ångras. All deras frånvarohistorik och saldon kommer att raderas.",
      "permanent_delete_final": "Detta är permanent! Klicka på OK för att bekräfta permanent borttagning.",
      "restore": "Är du säker på att du vill återställa den här användaren?",
      "cancel_invite": "Är du säker på att du vill avbryta den här inbjudan?"
    },
    "error": {
      "load": "Misslyckades med att ladda teammedlemmar",
      "save": "Misslyckades med att spara användare",
      "deactivate": "Misslyckades med att inaktivera användaren",
      "activate": "Misslyckades med att aktivera användaren",
      "delete": "Misslyckades med att ta bort användaren",
      "restore": "Misslyckades med att återställa användaren",
      "permanent_delete": "Misslyckades med att ta bort användaren permanent",
      "import": "Misslyckades med att importera användare",
      "invite": "Misslyckades med att skicka inbjudan",
      "email_exists": "En användare med denna e-postadress finns redan",
      "invalid_email": "Ogiltig e-postadress"
    }
  },
  "settings": {
    "page_title": "Inställningar",
    "page_subtitle": "Konfigurera dina arbetsyteinställningar och policyer",
    "access_denied": {
      "title": "Administratörsåtkomst krävs",
      "message": "Du behöver administratörsbehörighet för att komma åt inställningarna."
    },
    "tab": {
      "workspace": "Arbetsyta",
      "departments": "Avdelningar",
      "locations": "Platser",
      "holidays": "Helgdagar",
      "compliance": "Efterlevnad",
      "balances": "Ingående balanser",
      "notifications": "Aviseringar",
      "integrations": "Integrationer",
      "import": "Importera",
      "data_management": "Datahantering",
      "locked_tooltip": "Uppgradera för att låsa upp den här funktionen"
    },
    "workspace": {
      "title": "Arbetsyteinställningar",
      "name_label": "Arbetsytans namn",
      "visibility_label": "Lämna synlighet",
      "visibility": {
        "all": "Alla kan se alla lämna",
        "department": "Se endast egen avdelning",
        "approvers": "Endast godkännare kan se alla"
      },
      "save_button": "Spara ändringar"
    },
    "departments": {
      "title": "Avdelningar",
      "subtitle": "Organisera ditt team i avdelningar med anpassade policyer",
      "add_button": "Lägg till avdelning",
      "name_label": "Avdelningsnamn",
      "working_days_label": "Arbetsdagar",
      "hours_per_day_label": "Timmar per dag",
      "approvers_label": "Godkännare",
      "notification_channel_label": "Aviseringskanal",
      "policies_button": "Hantera policyer",
      "edit_button": "Redigera",
      "delete_button": "Radera",
      "confirm_delete": "Är du säker på att du vill ta bort den här avdelningen?",
      "no_departments": "Inga avdelningar skapade ännu"
    },
    "locations": {
      "title": "Platser",
      "subtitle": "Hantera kontorsplatser och deras helgdagskalendrar",
      "add_button": "Lägg till plats",
      "name_label": "Platsnamn",
      "country_label": "Land",
      "timezone_label": "Tidszon",
      "edit_button": "Redigera",
      "delete_button": "Radera",
      "no_locations": "Inga platser skapade än"
    },
    "holidays": {
      "title": "Helgdagar",
      "subtitle": "Hantera helgdagar för varje plats",
      "add_button": "Lägg till helgdag",
      "location_label": "Plats",
      "all_locations": "Alla platser",
      "year_label": "År",
      "name_label": "Helgdagsnamn",
      "date_label": "Datum",
      "half_day_label": "Halvdag",
      "edit_button": "Redigera",
      "delete_button": "Radera",
      "no_holidays": "Inga helgdagar för denna plats och år",
      "import_button": "Importera helgdagar"
    },
    "leave_types": {
      "title": "Typer av ledighet",
      "subtitle": "Konfigurera ledighettyper och rättigheter",
      "add_button": "Lägg till ledighettyp",
      "name_label": "Namn",
      "color_label": "Färg",
      "unit_label": "Enhet",
      "unit": {
        "days": "Dagar",
        "hours": "Timmar"
      },
      "entitlement_label": "Standardberättigande",
      "unlimited": "Obegränsat",
      "requires_approval_label": "Kräver godkännande",
      "allow_half_day_label": "Räkna med halvdag",
      "is_paid_label": "Betald ledighet",
      "carryover_label": "Max överföring",
      "priority_label": "Prioritet",
      "edit_button": "Redigera",
      "delete_button": "Radera",
      "no_leave_types": "Inga konfigurerade ledighettyper"
    },
    "notifications": {
      "title": "Aviseringar",
      "subtitle": "Konfigurera hur och när aviseringar skickas",
      "slack_channel_label": "Slack-kanalen",
      "email_notifications_label": "E-postmeddelanden",
      "daily_digest_label": "Daglig sammanfattning",
      "weekly_summary_label": "Veckovis sammanfattning",
      "save_button": "Spara inställningar"
    },
    "integrations": {
      "title": "Integrationer",
      "subtitle": "Koppla ihop dina HR-verktyg och kalendrar",
      "connect_button": "Ansluta",
      "disconnect_button": "Koppla från",
      "sync_button": "Synkronisera nu",
      "view_logs_button": "Visa loggar",
      "last_sync": "Senast synkroniserad: {datum}",
      "never_synced": "Aldrig synkroniserad",
      "status": {
        "connected": "Ansluten",
        "disconnected": "Inte ansluten",
        "error": "Fel"
      }
    },
    "data": {
      "title": "Datahantering",
      "subtitle": "Säkerhetskopiera dina data eller rensa arbetsyteinformation",
      "current_data": "Aktuella uppgifter",
      "total_users": "Totalt antal användare",
      "admins": "Administratörer",
      "regular_users": "Vanliga användare",
      "leave_requests": "Ledighetsansökningar",
      "backup": {
        "title": "Ladda ner säkerhetskopia",
        "description": "Ladda ner en fullständig säkerhetskopia av dina arbetsytedata som en JSON-fil.",
        "button": "Ladda ner säkerhetskopia"
      },
      "google_drive": {
        "title": "Google Drive-säkerhetskopiering",
        "description": "Automatiska dagliga säkerhetskopior till Google Drive.",
        "connect_button": "Anslut Google Drive",
        "folder_label": "Säkerhetskopieringsmapp",
        "auto_backup_label": "Aktivera automatisk daglig säkerhetskopiering",
        "backup_now_button": "Säkerhetskopiera nu",
        "last_backup": "Senaste säkerhetskopia: {datum}",
        "upgrade_message": "Automatiska dagliga säkerhetskopior till Google Drive är tillgängliga i Business-planen."
      },
      "clear_users": {
        "title": "Rensa icke-administratörsanvändare",
        "description": "Ta bort alla användare utom administratörer och ägare. Detta kommer att ta bort {count} användare, deras ledighetstillgångar och alla väntande ledighetsbegäranden.",
        "warning": "Varning: Den här åtgärden kan inte ångras. Se till att ladda ner en säkerhetskopia först.",
        "confirm_prompt": "Skriv DELETE för att bekräfta",
        "confirm_description": "Detta kommer att permanent ta bort {count} användare och all deras data.",
        "button": "Rensa icke-administratörsanvändare",
        "confirm_button": "Bekräfta borttagning av användare"
      },
      "clear_history": {
        "title": "Rensa frånvarohistorik",
        "description": "Ta bort alla ledighetsansökningar och återställ alla ledighetsaldon till noll. Detta kommer att radera {count} ledighetsansökningar.",
        "warning": "Varning: Den här åtgärden kan inte ångras. All frånvarohistorik kommer att raderas permanent och saldon återställas.",
        "confirm_description": "Detta kommer att permanent radera {count} ledighetsansökningar och återställa alla saldon.",
        "button": "Rensa frånvarohistorik",
        "confirm_button": "Bekräfta rensa historik"
      },
      "restore": {
        "title": "Återställ från säkerhetskopia",
        "description": "Ladda upp en säkerhetskopia av JSON-filen för att återställa dina arbetsytedata. Detta kommer att ersätta all befintlig data.",
        "warning": "Varning: Återställningen kommer att ersätta alla nuvarande användare, tjänstledighettyper, tjänstledighetsansökningar, avdelningar och saldon. Endast arbetsytans ägare kan utföra denna åtgärd.",
        "select_file": "Välj säkerhetskopia",
        "backup_details": "Säkerhetskopieringsdetaljer",
        "file": "Fil",
        "version": "Version",
        "created": "Skapad",
        "confirm_prompt": "Skriv ÅTERSTÄLL för att bekräfta",
        "confirm_description": "Detta kommer permanent att ersätta all befintlig data med säkerhetskopian.",
        "button": "Bekräfta återställning",
        "restoring": "Återställer...",
        "success": "Återställningen är slutförd!"
      }
    }
  },
  "audit": {
    "page_title": "Revisionslogg",
    "page_subtitle": "Visa alla ändringar som gjorts i din arbetsyta",
    "super_admin_label": "(Superadministratör)",
    "entries_count": "totalt antal poster",
    "filter": {
      "action_label": "Åtgärdstyp",
      "all_actions": "Alla åtgärder",
      "entity_label": "Enhetstyp",
      "all_entities": "Alla enheter",
      "user_label": "Ändrad av",
      "all_users": "Alla användare"
    },
    "action": {
      "user_updated": "Användaren uppdaterade",
      "user_deleted": "Användare borttagen",
      "user_imported": "Användarimporterad",
      "leave_requested": "Begärd ledighet",
      "leave_approved": "Ledighet godkänd",
      "leave_rejected": "Ledighet avvisad",
      "leave_cancelled": "Ledigheten avbruten",
      "leave_type_created": "Ledighetstyp skapad",
      "leave_type_updated": "Ledighetstyp uppdaterad",
      "leave_type_deleted": "Lämna bort typ",
      "balance_adjusted": "Justerat saldo",
      "department_created": "Avdelning skapad",
      "department_updated": "Avdelningen uppdaterad",
      "department_deleted": "Avdelning borttagen",
      "audit_log_deleted": "Granskningslogg borttagen"
    },
    "table": {
      "date": "Datum",
      "user": "Användare",
      "action": "Handling",
      "entity": "Enhet",
      "details": "Detaljer"
    },
    "no_entries": "Inga poster i granskningsloggen hittades"
  },
  "billing": {
    "page_title": "Fakturering och prenumeration",
    "page_subtitle": "Hantera din prenumeration och dina faktureringsuppgifter",
    "access_denied": {
      "title": "Åtkomst nekad",
      "message": "Endast arbetsytans ägare kan visa och hantera fakturering.",
      "button": "Återgå till instrumentpanelen"
    },
    "current_plan": {
      "title": "Nuvarande plan"
    },
    "status": {
      "none": "Ingen prenumeration"
    },
    "discount_badge": "{procent}% rabatt tillämpad",
    "trial_info": {
      "title": "Testperioden slutar {datum}",
      "days_remaining": "{dagar} dagar kvar"
    },
    "renewal_info": {
      "title": "Nästa faktureringsdatum"
    },
    "action": {
      "upgrade": "Uppgradera till Pro",
      "view_plans": "Visa alla planer",
      "manage": "Hantera prenumeration"
    },
    "plan": {
      "trial": "Gratis provperiod",
      "free": "Gratis",
      "pro": "Pro",
      "business": "Företag"
    },
    "feature": {
      "up_to_5_users": "Upp till 5 användare",
      "up_to_50_users": "Upp till 50 användare",
      "unlimited_users": "Obegränsade användare",
      "basic": "Grundläggande funktioner",
      "trial_14days": "14-dagars provperiod",
      "unlimited_requests": "Obegränsade ledighetsansökningar",
      "slack_integration": "Slack-integration",
      "planner": "Planeringsvy",
      "custom_leave_types": "Anpassade ledighettyper",
      "approval_workflows": "Godkännandearbetsflöden",
      "priority_support": "Prioriterat stöd",
      "multi_team": "Stöd för flera team",
      "analytics": "Avancerad analys",
      "api_access": "API-åtkomst",
      "dedicated_support": "Dedikerat stöd"
    }
  },
  "upgrade": {
    "page_title": "Välj din plan",
    "page_subtitle": "Enkel och transparent prissättning. Inga avgifter per användare.",
    "plan_badge": "Mest populära",
    "period": {
      "month": "/månad",
      "year": "/år"
    },
    "yearly_savings": "eller EUR {årligen}/år (spara {procent}%)",
    "loading": "Laddar planer...",
    "guarantee": {
      "title": "30-dagars pengarna-tillbaka-garanti",
      "description": "Inte nöjd? Få full återbetalning, utan några frågor."
    },
    "faq": {
      "title": "Vanliga frågor",
      "q1": "Kan jag ändra planer senare?",
      "a1": "Ja, du kan uppgradera eller nedgradera när som helst. Ändringarna träder i kraft omedelbart och beräknas proportionellt.",
      "q2": "Vilka betalningsmetoder accepterar ni?",
      "a2": "Vi accepterar alla större kreditkort (Visa, Mastercard, American Express) via vår säkra betalningsleverantör Stripe.",
      "q3": "Finns det ett kontrakt eller ett åtagande?",
      "a3": "Nej, alla planer gäller månadsvis. Du kan avsluta när som helst utan avgifter.",
      "q4": "Vad händer när jag når min användargräns?",
      "a4": "Du kommer att bli ombedd att uppgradera till ett högre abonnemang. Befintliga användare kommer att fortsätta ha åtkomst."
    },
    "contact_note": "Har du frågor? Kontakta oss på",
    "current_plan_badge": "Nuvarande plan",
    "button": {
      "upgrade": "Uppgradera till {plan}",
      "start_trial": "Starta gratis provperiod"
    }
  },
  "login": {
    "processing_title": "Loggar in dig...",
    "processing_message": "Vänta medan vi verifierar dina inloggningsuppgifter från Slack.",
    "subtitle": "Hantera ditt teams ledighetsansökningar enkelt",
    "slack_button": "Lägg till i Slack",
    "existing_user_text": "Använder du redan Unplug?",
    "existing_user_info": "Öppna appen i Slack och klicka på Admin Dashboard för att logga in.",
    "terms_text": "Genom att fortsätta",
    "error": {
      "workspace_not_found": "Arbetsytan hittades inte. Kontrollera URL:en.",
      "invalid_response": "Ogiltigt svar från servern",
      "generic": "Inloggningen misslyckades",
      "please_retry": "Inloggningen misslyckades. Försök igen."
    }
  },
  "help": {
    "page_title": "Hjälpcenter",
    "page_subtitle": "Hitta svar och lär dig hur du använder Unplug",
    "action": {
      "restart_tour": "Starta om rundturen"
    },
    "search": {
      "placeholder": "Sök hjälpartiklar, vanliga frågor...",
      "results": "Hittade {articles} artiklar och {faqs} vanliga frågor som matchar {query}"
    },
    "quick_link": {
      "getting_started": "Komma igång",
      "faqs": "Vanliga frågor",
      "contact_support": "Kontakta supporten",
      "tour": "Ta rundturen"
    }
  },
  "profile": {
    "page_title": "Profilinställningar",
    "personal_info": "Personlig information",
    "name_label": "Fullständigt namn",
    "email_label": "E-post",
    "department_label": "Avdelning",
    "location_label": "Plats",
    "manager_label": "Chef",
    "start_date_label": "Startdatum",
    "save_button": "Spara ändringar",
    "preferences": "Inställningar",
    "language_label": "Språk",
    "timezone_label": "Tidszon"
  },
  "planner": {
    "page_title": "Planerare",
    "page_subtitle": "Visuell teamkalender som visar alla frånvaron",
    "feature_name": "Planerare",
    "feature_description": "Visuell teamkalender som visar alla frånvaron i en överblick",
    "empty_state": "Inga teammedlemmar hittades",
    "filter": {
      "pending_request": "Väntande förfrågan",
      "filter_by": "Filtrera efter",
      "department": "Avdelning",
      "all_departments": "Alla avdelningar",
      "location": "Plats",
      "all_locations": "Alla platser"
    },
    "export": {
      "button": "Exportera",
      "title": "Exportera ledighetsdata",
      "format": "Exportformat",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "Generisk CSV",
      "date_range": "Datumintervall",
      "departments": "Avdelningar"
    },
    "legend": {
      "approved": "Godkänd",
      "pending": "Väntande",
      "holiday": "Helgdag",
      "holidays": "Helgdagar",
      "weekend": "Helg",
      "non_working": "Icke-arbetsdag",
      "partial_day": "Frånvaro kortare än en dag"
    },
    "no_data": "Inga frånvaron att visa"
  },
  "error": {
    "network": "Nätverksfel. Kontrollera din anslutning.",
    "unauthorized": "Du har inte behörighet att utföra den här åtgärden.",
    "not_found": "Den begärda resursen hittades inte.",
    "server": "Serverfel. Försök igen senare.",
    "validation": "Kontrollera formuläret för fel.",
    "generic": "Något gick fel. Försök igen.",
    "session_expired": "Din session har löpt ut. Vänligen logga in igen."
  },
  "success": {
    "saved": "Ändringarna har sparats.",
    "deleted": "Raderad.",
    "created": "Skapad.",
    "updated": "Uppdaterad.",
    "submitted": "Inskickad.",
    "sent": "Skickat."
  },
  "weekday": {
    "monday": "måndag",
    "tuesday": "tisdag",
    "wednesday": "onsdag",
    "thursday": "torsdag",
    "friday": "Fredag",
    "saturday": "Lördag",
    "sunday": "söndag",
    "mon": "mån",
    "tue": "Tis",
    "wed": "ons",
    "thu": "tors",
    "fri": "fre",
    "sat": "lör",
    "sun": "Solen"
  },
  "month": {
    "january": "januari",
    "february": "februari",
    "march": "Mars",
    "april": "april",
    "may": "Maj",
    "june": "Juni",
    "july": "Juli",
    "august": "Augusti",
    "september": "september",
    "october": "oktober",
    "november": "november",
    "december": "December",
    "jan": "Jan",
    "feb": "februari",
    "mar": "Mars",
    "apr": "april",
    "may_short": "Maj",
    "jun": "juni",
    "jul": "Juli",
    "aug": "Aug",
    "sep": "Sep",
    "oct": "okt",
    "nov": "nov",
    "dec": "dec"
  },
  "language": {
    "en": "Engelska",
    "es": "Spanska",
    "fr": "franska",
    "de": "Tyska",
    "it": "Italienska",
    "pt": "Portugisiska",
    "pl": "Polska",
    "nl": "holländska",
    "sv": "Svenska",
    "no": "norska"
  },
  "leave_type_name": {
    "Vacation": "Semester",
    "Vacation Leave": "Semester",
    "Annual Leave": "Årlig ledighet",
    "Unpaid Vacation": "Obetald ledighet",
    "Unpaid Leave": "Obetald ledighet",
    "Sick Leave": "Sjukfrånvaro",
    "Sick Leave (Full Pay)": "Sjukfrånvaro (full lön)",
    "Maternity Leave": "Mammaledighet",
    "Paternity Leave": "Pappaledighet",
    "Parental Leave": "Föräldraledighet",
    "Bereavement Leave": "Ledighet vid dödsfall",
    "Marriage Leave": "Ledighet för bröllop",
    "Jury Leave": "Ledighet för nämndemansuppdrag",
    "Jury Duty": "Nämndemansuppdrag",
    "Work Travel": "Tjänsteresa",
    "Working Remotely": "Distansarbete",
    "Remote Work": "Distansarbete",
    "Work From Home": "Hemarbete",
    "Personal Day": "Personlig dag",
    "TOIL": "Kompledighet",
    "Time Off In Lieu": "Kompledighet",
    "Compassionate Leave": "Ledighet av personliga skäl",
    "Study Leave": "Studieledighet",
    "Training": "Utbildning",
    "Public Holiday": "Helgdag"
  }
}